import Header from "../../Components/Header"
import { ProfileColored, InformationIcon, FlashIcon, SettingsIcon, DeleteIcon } from "../../utils/iconFactory"
import { TertiaryButton, TertiaryGrayButton } from "../../Components/Elements/CustomButtons"
import { useContext, useState } from "react"
import { StateContext } from "../../services/context"
import { SubscriptionModal } from "../../Components/Modals/SubscriptionModal"
import { CancelSubscriptionModal } from "../../Components/Modals/CancelSubscriptionModal"
import { DeleteAllDocumentModal } from "../../Components/Modals/Documents/DeleteAllDocumentsModal"
import { api } from "../../services/POST"
import HelperModal, { HelperButton } from "../../Components/HelperComponents"

export default function Profile() {
  const { user, setLoadedDocument, showPopup } = useContext(StateContext)
  const [ isCancelModalVisible, setIsCancelModalVisible ] = useState<boolean>(false)
  const [ isSubcriptionModalVisible, setSubcriptionModalVisible ] = useState<boolean>(false)
  const [ helperModalVisible, setHelperModalVisible ] = useState<boolean>(false);
  const [ openDeleteAllModalVisible, setOpenDeleteAllModalVisible ] = useState<boolean>(false);

  const removeAllDocuments = async () => {
    try {
      await api("/delete_all_document")

      setLoadedDocument({id: '', name: '', data: '', date: ''});

      showPopup("Sikeresen törölted az összes dokumentumot!", "success");
    } catch (err: any) {
      console.error(err);
    }
  };
  function timeoutConverter(data: any) {
    if (data.includes('T')) return data.split('T')[0];
    if (data.includes(' ')) return data.split(' ')[0];
    return data;
  }

  return (
    <>
      <Header>
        <div id='documents-custom-header' className="flex items-center justify-center">
          <h2 id='documents-header-text' className="text-textMain text-style-h2">Profil</h2>
        </div>
      </Header>
      <HelperModal isVisible={helperModalVisible} onClose={() => {setHelperModalVisible(false)}} modalContentType="profile" />
      {!helperModalVisible && (<HelperButton onClick={() => setHelperModalVisible(true)} />)}
      <SubscriptionModal 
        isVisible={isSubcriptionModalVisible} 
        onClose={() => setSubcriptionModalVisible(false)} 
      />
      <CancelSubscriptionModal isVisible={isCancelModalVisible} onClose={() => setIsCancelModalVisible(false)} />
      <DeleteAllDocumentModal isVisible={openDeleteAllModalVisible} onClose={() => setOpenDeleteAllModalVisible(false)} execute={removeAllDocuments} />
      <div className="flex flex-1 flex-col w-full bg-backgroundWhite overflow-y-auto no-scrollbar">
        <div id='separator' className="h-[86px]"/>
        <main className="flex flex-1 flex-col w-full p-10 relative rounded-t-[16px] bg-backgroundWhite">
          <div id='first-row' className="flex flex-wrap gap-[26px]">
            <div id='profile-data-card' className="flex flex-col gap-4 rounded-[24px] bg-backgroundLightGray p-8 h-[280px] w-[596px]">
              <div id='card-header' className="flex gap-2 items-center">
                <ProfileColored id='card-icon' className="h-12 w-12" />
                <h1 id='card-name' className="text-style-sub1 text-textMain">Profil adatok</h1>
              </div>
              <div id="webshop-name" className="flex gap-2 text-textMain">
                <p className="text-style-body2">Webáruház neve:</p>
                <p className="text-style-body2-bold">{user.shopname}</p>
              </div>
              <div id="email-address" className="flex gap-2 text-textMain">
                <p className="text-style-body2">E-mail cím:</p>
                <p className="text-style-body2-bold">{user.email}</p>
              </div>
              <div id="info" className="flex gap-2 pt-4">
                <InformationIcon className="h-6 w-6 text-gray150 fill-current" />
                <p className="text-gray150 text-style-small">Beállításaid a Shoprenteren belül tudot megváltoztatni a Beállítások oldalon.</p>
              </div>
            </div>

            <div id='subcription-card' className="flex flex-col gap-4 rounded-[24px] bg-backgroundLightGray p-8 h-[280px] w-[596px]">
              <div id='card-header' className="flex gap-2 items-center">
                <FlashIcon id='card-icon' className="h-12 w-12" />
                <h1 id='card-name' className="text-style-sub1 text-textMain">Előfizetés</h1>
              </div>
              <div id="webshop-name" className="flex gap-2 text-textMain">
                <p className="text-style-body2">Jelenlegi csomag:</p>
                <p className="text-style-body2-bold capitalize ">{(user.plan).endsWith("_year") ? ((user.plan).slice(0, -"_year".length) + " (Éves)") : (user.plan)}</p>
              </div>
              <div id="email-address" className="flex gap-2 text-textMain">
                <p className="text-style-body2">{user.plan === 'free' ? "Próbaidőszak vége:" : "Előfizetés megújul:"}</p>
                <p className="text-style-body2-bold">{timeoutConverter(user.timeout)}</p>
              </div>
              <div id="info" className="flex justify-between pt-6 -mx-4">
                <TertiaryButton 
                  buttonInfo={{label: "Előfizetés megváltoztatása"}} 
                  onClick={() => setSubcriptionModalVisible(true)}
                />
                {(user.plan !== 'standard' && user.plan !== 'free') &&
                  <TertiaryGrayButton 
                    buttonInfo={{label: "Előfizetés lemondása"}} 
                    onClick={() => setIsCancelModalVisible(true)}
                  />
                }
              </div>
            </div>

            <div id='settings-card' className="flex flex-col gap-4 rounded-[24px] bg-backgroundLightGray p-8 h-[280px] w-[596px]">
              <div id='card-header' className="flex gap-2 items-center">
                <SettingsIcon id='card-icon' className="h-12 w-12" />
                <h1 id='card-name' className="text-style-sub1 text-textMain">AIDA Beállítások</h1>
              </div>
              <div>
                <p id="documents" className="text-style-body2-bold text-textMain">Dokumentumok</p>
                <TertiaryGrayButton 
                  buttonInfo={{label: "Összes dokumentum törlése", buttonIcon: DeleteIcon}} 
                  onClick={() => setOpenDeleteAllModalVisible(true)}
                  className="-mx-5"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}